import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import productReducer from "../features/product";
import contactReducer from "../features/contactInquiry";
import cmsReducer from "../features/cms/cmsSlice";
import productInquiryReducer from "../features/cms/cmsSlice";
import paymentReducer from "../features/payment";
import countryReducer from "../features/country";
import companyReducer from "../features/company/companySlice";
import ropReducer from "../features/rop/ropSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productReducer,
    contact: contactReducer,
    cms: cmsReducer,
    productInquiry: productInquiryReducer,
    payment: paymentReducer,
    company: companyReducer,
    country: countryReducer,
    rop: ropReducer,
  },
});
